define('plugin/invoice/view/InvoiceButtonsView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Invoice buttons view
     *
     * @class InvoiceButtonsView
     */
    return LayoutView.extend({

        template: '#invoice_buttons_view',
        modelEvents: {
            'sync': 'safeRender'
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        serializeData: function () {
            var result = _.extend(
                LayoutView.prototype.serializeData.apply(this),
                this.model.getLineTypes(), {
                    allow_print: Config.getInstance().isExternalLinkWithAuthAllowed() && this.model.isPrintAllowed()
                }
            );
            if (result && result.lines) {
                result.lines = result.lines.toJSON();
            }

            result.show_buttons = this.getOption('showButtons');

            return result;
        }

    });

});
